module.exports = __webpack_public_path__ + "img/loader.382ba89f.svg";